export default "__VITE_ASSET__afaa44fa__"